module.exports = __webpack_public_path__ + "static/img/6.259ada9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/6.png
// module id = cwMx
// module chunks = 0